import { render, staticRenderFns } from "./HelpCenterLayout.vue?vue&type=template&id=48565e22&scoped=true&"
import script from "./HelpCenterLayout.vue?vue&type=script&lang=js&"
export * from "./HelpCenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterLayout.vue?vue&type=style&index=0&id=48565e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48565e22",
  null
  
)

export default component.exports